import { useEffect } from 'react';

// Robust background scroll lock for mobile overlays. `body { overflow: hidden }` is
// NOT honoured by iOS Safari for touch scrolling, so the page scrolls behind the
// sheet. The reliable cross-browser fix is `position: fixed` on <body> with the
// scroll offset preserved. Ref-counted at module scope so nested overlays (e.g. the
// wallet connect sheet opening on top of Review & Sign) don't fight: only the first
// lock pins the body, only the last unlock restores it and scrolls back.

let lockCount = 0;
let savedScrollY = 0;
let savedStyles = null;

function lock() {
  if (lockCount === 0 && typeof document !== 'undefined') {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    const b = document.body.style;
    savedStyles = { position: b.position, top: b.top, left: b.left, right: b.right, width: b.width, overflow: b.overflow };
    b.position = 'fixed';
    b.top = `-${savedScrollY}px`;
    b.left = '0';
    b.right = '0';
    b.width = '100%';
    b.overflow = 'hidden';
  }
  lockCount++;
}

function unlock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0 && savedStyles) {
    const b = document.body.style;
    b.position = savedStyles.position;
    b.top = savedStyles.top;
    b.left = savedStyles.left;
    b.right = savedStyles.right;
    b.width = savedStyles.width;
    b.overflow = savedStyles.overflow;
    savedStyles = null;
    window.scrollTo(0, savedScrollY);
  }
}

export function useScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    lock();
    return unlock;
  }, [active]);
}
